'use client';

import { useEffect, useState } from 'react';

const NARROW_MQ = '(max-width: 720px)';

/** True when viewport matches the lists/share mobile chrome breakpoint. */
export function useNarrowScreen(): boolean {
  const [narrow, setNarrow] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(NARROW_MQ).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia(NARROW_MQ);
    const apply = () => setNarrow(mq.matches);
    apply();
    mq.addEventListener('change', apply);
    return () => mq.removeEventListener('change', apply);
  }, []);

  return narrow;
}
